import { ViewStyle } from "react-native";
import { ThemeStyle } from "../../Style.types";

export interface IBorderClassGroup {
  border0: ViewStyle;
  border2: ViewStyle;
  border4: ViewStyle;
  border8: ViewStyle;
  border16: ViewStyle;
  border24: ViewStyle;
  border32: ViewStyle;
  border40: ViewStyle;
  border48: ViewStyle;
  rounded: ViewStyle;
  unrounded: ViewStyle;
  roundedTop: ViewStyle;
  roundedBottom: ViewStyle;
  roundedLeft: ViewStyle;
  roundedRight: ViewStyle;
  borderPrimary: ThemeStyle;
  borderSecondary: ThemeStyle;
  borderSuccess: ThemeStyle;
  borderDanger: ThemeStyle;
  borderWarning: ThemeStyle;
  borderInfo: ThemeStyle;
  borderLight: ThemeStyle;
  borderDark: ThemeStyle;
  borderSolid: ViewStyle;
  borderBottomSolid: ViewStyle;
  borderRight: ViewStyle;
}

export const BorderClassGroup: IBorderClassGroup = {
  border0: { borderWidth: 0 },
  border2: { borderWidth: 2 },
  border4: { borderWidth: 4 },
  border8: { borderWidth: 8 },
  border16: { borderWidth: 16 },
  border24: { borderWidth: 24 },
  border32: { borderWidth: 32 },
  border40: { borderWidth: 40 },
  border48: { borderWidth: 48 },
  borderSolid: { borderStyle: "solid" },
  borderBottomSolid: { borderTopWidth: 0, borderLeftWidth: 0, borderRightWidth: 0 },
  borderRight: { borderRightWidth: 3, borderTopRightRadius: 2, borderBottomRightRadius: 2 },
  rounded: { borderRadius: 8 },
  unrounded: { borderRadius: 0 },
  roundedTop: { borderTopLeftRadius: 8, borderTopRightRadius: 8 },
  roundedBottom: { borderBottomLeftRadius: 8, borderBottomRightRadius: 8 },
  roundedLeft: { borderTopLeftRadius: 8, borderBottomLeftRadius: 8 },
  roundedRight: { borderTopRightRadius: 8, borderBottomRightRadius: 8 },
  borderPrimary: (theme) => ({
    borderColor: theme.colors.primary.main,
  }),
  borderSecondary: (theme) => ({
    borderColor: theme.colors.secondary.main,
  }),
  borderSuccess: (theme) => ({
    borderColor: theme.colors.success.main,
  }),
  borderDanger: (theme) => ({
    borderColor: theme.colors.danger.main,
  }),
  borderWarning: (theme) => ({
    borderColor: theme.colors.warning.main,
  }),
  borderInfo: (theme) => ({
    borderColor: theme.colors.info.main,
  }),
  borderLight: (theme) => ({
    borderColor: theme.colors.neutralLighter.main,
  }),
  borderDark: (theme) => ({
    borderColor: theme.colors.neutralDarker.main,
  }),
};
